export const amenities_rooms = {
  /*1: {
    label: "Bollitore tè macchina caffè",
    icon: ""
  },*/
}

export function get_amenities_rooms(key) {
  const amenity = amenities_rooms[key]
  if (amenity !== undefined) return amenity
  return { label: key, icon: "check_circle" }
}